export function checkUa() {
  const ua = navigator.userAgent;
  if (/jzh/.test(ua)) {
    if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
      return "xes_ios";
    } else if (ua.includes("Android") || ua.includes("Adr")) {
      return "xes_android";
    }
  }
}

export function login(url) {
  if (checkUa() === "xes_ios" || checkUa() === "xes_android") {
    window.xesAppLogin = () => {
      window.location.href = url || window.location.href;
    };
    window.xesApp && window.xesApp.xesLogin("xesAppLogin");
    return;
  }
  window.location.href = `//login.xueersi.com/?redirect_url=${encodeURIComponent(
    url || window.location.href
  )}`;
}

export function logout() {
  const url = encodeURIComponent(window.location.href);
  const loginUrl = encodeURIComponent(
    `//login.xueersi.com/?from=touch&redirect_url=${encodeURIComponent(url)}`
  );
  window.location.href = `//login.xueersi.com/newLogin/logout/?redirect_url=${encodeURIComponent(
    loginUrl
  )}`;
}

export function processData(item, source) {
  // source 来源 courseList为2 extraCourseList为20
  item.source = source;
  item.tagNames = [];
  if (item.courseInfo.subjectName) {
    item.tagNames.push({
      text: item.courseInfo.subjectName,
      type: "subject",
    });
  }
  if (item.courseInfo.schooltimeName && item.courseInfo.planNum) {
    item.productDesc = `${item.courseInfo.schooltimeName} · 共${item.courseInfo.planNum}讲`;
  } else if (item.courseInfo.schooltimeName) {
    item.productDesc = item.courseInfo.schooltimeName;
  } else if (item.courseInfo.planNum) {
    item.productDesc = `共${item.courseInfo.planNum}讲`;
  }
  if (item.courseInfo.difficultyAlias) {
    item.difficultyId = item.courseInfo.difficultyAlias;
  }
  if (item.teacherInfo) {
    item.teachers = [];
    const speakers = item.teacherInfo.filter((e) => e.type == 1);
    if (speakers.length) {
      item.teachers.push({
        img: speakers[0]?.img,
        name: speakers[0]?.name,
        title: "授课",
        multiple: speakers.length > 1,
      });
    }
    const partTimes = item.teacherInfo.filter((e) => e.type == 2);
    if (partTimes.length) {
      item.teachers.push({
        img: partTimes[0]?.img,
        name: partTimes[0]?.name,
        title: "授课",
        multiple: partTimes.length > 1,
      });
    }
    const foreigners = item.teacherInfo.filter((e) => e.type == 5);
    if (foreigners.length) {
      item.teachers.push({
        img: foreigners[0]?.img,
        name: foreigners[0]?.name,
        title: "外教",
        multiple: foreigners.length > 1,
      });
    }
    const counselors = item.teacherInfo.filter((e) => e.type == 4);
    if (counselors.length) {
      item.teachers.push({
        img: counselors[0]?.img,
        name: counselors[0]?.name || "老师",
        title: "班主任",
        multiple: counselors.length > 1,
      });
    }
    const exclusives = item.teacherInfo.filter((e) => e.type == 7);
    if (exclusives.length) {
      item.teachers.push({
        img: exclusives[0]?.img,
        name: exclusives[0]?.name || "专属老师",
        title: "全程陪伴",
        multiple: exclusives.length > 1,
      });
    }
    const coaches = item.teacherInfo.filter((e) => e.type == 9);
    if (coaches.length) {
      item.teachers.push({
        img: coaches[0]?.img,
        name: coaches[0]?.name || "专职辅导",
        title: "班主任",
        multiple: coaches.length > 1,
      });
    }
  }
  if (!item.totalStatus || (item.totalStatus && item.totalStatus.status == 1)) {
    if (item?.couClassStatus?.showMsg && item?.couSaleStatus?.status != 2) {
      item.couClassStatus.showMsg = "";
    }
    if (
      item.couClassStatus &&
      item.couClassStatus.showMsg &&
      item.couSaleStatus &&
      item.couSaleStatus.showMsg
    ) {
      item.hintMessage = `${item.couClassStatus.showMsg} · ${item.couSaleStatus.showMsg}`;
    } else if (item.couClassStatus && item.couClassStatus.showMsg) {
      item.hintMessage = item.couClassStatus.showMsg;
    } else if (item.couSaleStatus && item.couSaleStatus.showMsg) {
      item.hintMessage = item.couSaleStatus.showMsg;
    }
  }
  processPrice(item);
  if (item.detailUrl && item.courseId && item.classId) {
    item.detailUrl = `${item.detailUrl}${item.courseId}/${item.classId}?hideBottomBar=1&trustClass=1`;
  }
}

export function processPrice(item) {
  if (item.priceInfo) {
    if (item.priceInfo.promMsg) {
      item.price = `￥${item.priceInfo.originPrice}`;
      item.priceExplain = item.priceInfo.promMsg;
      item.promotionPrice = item.priceInfo.salePrice;
    } else {
      item.price = "";
      item.priceExplain = "";
      item.promotionPrice = item.priceInfo.salePrice;
    }
  }
}

export function openWithWebview(url) {
  if (checkUa() === "xes_android") {
    window.location.href = `xeswangxiao://xrsApp?m=webbrowser&d={"p":{"url":"${encodeURIComponent(
      url
    )}"}}`;
  } else {
    window.location.href = url;
  }
}
